import React from 'react';
import './App.css';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import Settings from './components/Settings';
import DetailView from './components/DetailView';
import { AssetContextProvider } from './contexts/AssetContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <AssetContextProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Header />
          <main className="container mx-auto px-4 py-8">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/detail/:source" element={<DetailView />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AssetContextProvider>
  );
}

export default App;
